export class NGXSelectMayRow{
    isSelected:boolean;
    data:any;
    value:any;
    label:string;

    constructor(isSelected:boolean, data:any){
        this.isSelected = isSelected;
        this.data = data;
    }

    setKey(value:any){
        this.value = value;
    }

    setLabel(label:string){
        this.label = label;
    }
}


export class NGXSelectMayConfigs{


    public static readonly ROW_ACTIVE_CLASS = "active";
    public static readonly EMPTY_TEXT = "No results found";
    public static readonly MULTI_SELECTED_LABEL = "#COUNT #ITEMS Selected";
    public static readonly LOADING_TEXT = "Please wait...";

    private _labelField: string = "";
    public get labelField(): string {
        return this._labelField;
    }
    public set labelField(value: string) {
        this._labelField = value;
    }

    private _valueField: any;
    public get valueField(): any {
        return this._valueField;
    }
    public set valueField(value: any) {
        this._valueField = value;
    }

    private _placeholderText: string = "";
    public get placeholderText(): string {
        return this._placeholderText;
    }
    public set placeholderText(value: string) {
        this._placeholderText = value;
    }

    private _emptyText: string = "";
    public get emptyText(): string {
        return this._emptyText;
    }
    public set emptyText(value: string) {
        this._emptyText = value;
    }

    private _showEmptyResultsLabel: boolean = true;
    public get showEmptyResultsLabel(): boolean {
        return this._showEmptyResultsLabel;
    }
    public set showEmptyResultsLabel(value: boolean) {
        this._showEmptyResultsLabel = value;
    }

    private _cssClass: string = "";
    public get cssClass(): string {
        return this._cssClass;
    }
    public set cssClass(value: string) {
        this._cssClass = value;
    }


    private _isMultiSelect: boolean;
    public get isMultiSelect(): boolean {
        return this._isMultiSelect;
    }
    public set isMultiSelect(value: boolean) {
        this._isMultiSelect = value;
    }

}